const equipementsItems = [
  
  {
    nom: "Draps (Lits faits à l'arrivée) ",
    image: "./assets/public/equipement/bedMade.svg",
    alt: "Icône Draps et linge de toilette"
  },
    {
      nom: "Serviettes fournies ",
      image: "./assets/public/equipement/bedding.svg",
      alt: "Icône Draps et linge de toilette"
    },
    {
      nom: "Lave-linge",
      image:  "./assets/public/equipement/laundrymachine.svg",
      alt: "Lave-linge"
    },
    {
      nom: "Lave-vaisselle",
      image:  "./assets/public/equipement/dishwasher.svg",
      alt: "Lave-vaisselle"
    },
    {
      nom: "Télévision",
      image: "./assets/public/equipement/tv.svg",
      alt: "Icône Télévision"
    },
    {
      nom: "Wifi",
      image: "./assets/public/equipement/wifi.svg",
      alt: "Icône Wifi"
    },
  {
      nom: "Terrain de  pétanque",
      image: "./assets/public/equipement/balon.svg",
      alt: "Balon"
    }
  ];
  export { equipementsItems };  // Exportation nommée
  export default equipementsItems;  // Exportation par défaut
